import ServerDirections from '@/config/server-directions'
import { Transaction } from '@/entities/Transaction'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

var snakeCaseKeys = require('snakecase-keys')

export class TransactionRequests {
  get (id) {
    const route = ServerDirections.TRANSACTIONS_ID.replace('{id}', id)
    const method = 'get'
    function map (data) {
      return new Transaction(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }
  save (transaction) {
    const route = ServerDirections.TRANSACTIONS
    const method = 'post'
    function map (data) {
      return data[0]
    }
    const body = [snakeCaseKeys(transaction)]
    return requestService.makePromise(route, method, { body }, map)
  }
}
